import { useTheme } from 'contexts'
import React from 'react'
import { ActivityIndicator } from 'react-native'

import { ThemeColor } from 'utils/themes/types'

export const LoadingSpinner = ({
  size = 'large',
  color = 'v2primary',
}: {
  size?: 'small' | 'large'
  color?: ThemeColor
}) => {
  const theme = useTheme()
  const activityIndicatorColor = theme.colors[color]
  return <ActivityIndicator size={size} color={activityIndicatorColor} />
}
